import { IonButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useHistory } from 'react-router';
import WatchInterviews from '../../components/interview/WatchInterviews';
import { CustomRoutes } from '../../utils/CustomRoutes';
import LoginComponent from '../../components/common/LoginComponent';

const WatchInterviewsPage: React.FC = () => {
  const history = useHistory();
  const goToViewInterviews = () => {
    history.push(CustomRoutes.viewInterview);
  }
  let orgPageTitle = "Watch Interviews"
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>
            {orgPageTitle}
            <IonButton className='ion-float-right ion-float-xs-left' onClick={goToViewInterviews}>View Interviews</IonButton>
          </IonTitle>
          <IonButtons slot='end'>
            <LoginComponent></LoginComponent>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar color="primary">
            <IonTitle size="large">{orgPageTitle}</IonTitle>
            {/* <IonButton>View Interviews</IonButton> */}
          </IonToolbar>
        </IonHeader>
        <WatchInterviews name={'watch finished interview'}></WatchInterviews>
      </IonContent>
    </IonPage>
  );
};

export default WatchInterviewsPage;
